import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IApiResponse } from 'src/app/_Models/Base/iapi-response';
import { IPongResponse } from 'src/app/_Models/ipong-response';
import { IApihUser } from 'src/app/_Models/User/iapih-user';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class ExaScanUser {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiEndpoint}/${environment.apiEndpointLang}/${environment.apiEndpointApp}`;

  private _currentUser = signal<IApihUser | null>(null);
  public currentUser = this._currentUser.asReadonly();

  testPingBackend(): Observable<IApiResponse<IPongResponse>> {
    return this.http.get<IApiResponse<IPongResponse>>(`${this.baseUrl}/Ping/send`);
  }

  loadCurrentUser(): Observable<IApihUser> {
    return this.http.get<IApihUser>(`${this.baseUrl}/ExaScan/WhoAmI`).pipe(
      tap(user => this._currentUser.set(user))
    );
  }
}
  ///TODO: Add more user related API calls here
//   export interface SearchResult<T> {
//   items: T[];
//   totalCount: number;
//   page: number;
//   pageSize: number;
//   totalPages: number;
//   hasNextPage: boolean;
//   hasPreviousPage: boolean;
// }

// // Gebruik
// searchUsers(searchTerm: string, page: number = 1): Observable<SearchResult<UserSearchDto>> {
//   return this.http.get<SearchResult<UserSearchDto>>(`api/user/search`, {
//     params: { searchTerm, page: page.toString(), pageSize: '50' }
//   });
// }
